import util from '@bmp-vue/core/api/util';
const controller = 'Sarfaty';
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Arranjos: [
    { value: ' ', text: 'Todos' },
    { value: 'ACC', text: 'Amex Cartão de Crédito' },
    { value: 'BCC', text: 'Banescard Cartão de Crédito' },
    { value: 'BCD', text: 'Banescard Cartão de Débito' },
    { value: 'BVV', text: 'Ben Visa Vale' },
    { value: 'CAC', text: 'Cielo Amex Crédito' },
    { value: 'CBC', text: 'Cabal Crédito' },
    { value: 'CBD', text: 'Cabal Débito' },
    { value: 'CBP', text: 'Cabal Pré-Pago' },
    { value: 'CDC', text: 'Cielo Diners Cartão de Crédito' },
    { value: 'CEC', text: 'Cielo Elo Cartão de Crédito' },
    { value: 'CED', text: 'Cielo Elo Cartão de Débito' },
    { value: 'CHC', text: 'Cielo Hipercard Crédito' },
    { value: 'CMC', text: 'Cielo Mastercard Crédito' },
    { value: 'CMD', text: 'Cielo Mastercard Débito' },
    { value: 'CZC', text: 'CREDZ Crédito' },
    { value: 'DCC', text: 'Diners Cartão de Crédito' },
    { value: 'ECC', text: 'Elo Cartão de Crédito' },
    { value: 'ECD', text: 'Elo Cartão de Débito' },
    { value: 'GCC', text: 'Goodcard Crédito' },
    { value: 'GDC', text: 'Global Payments Diners Crédito' },
    { value: 'GMC', text: 'Global Payments MasterCard Crédito' },
    { value: 'GMD', text: 'Global Payments MasterCard Débito' },
    { value: 'GVC', text: 'Global Payments VISA Crédito' },
    { value: 'GVD', text: 'Global Payments VISA Débito' },
    { value: 'HCC', text: 'Hipercard Cartão de Crédito' },
    { value: 'JCC', text: 'JCB Cartão de Crédito' },
    { value: 'MAC', text: 'Mais Cartão de Crédito' },
    { value: 'MCA', text: 'MasterCard Cartão ATM' },
    { value: 'MCC', text: 'Mastercard Cartão de Crédito' },
    { value: 'MCD', text: 'Mastercard Cartão de Débito' },
    { value: 'MCP', text: 'Mastercard Cartão Pré-Pago' },
    { value: 'OCD', text: 'Ourocard Cartão de Débito' },
    { value: 'SCC', text: 'Sorocred Cartão de Crédito' },
    { value: 'SCD', text: 'Sorocred Cartão de Débito' },
    { value: 'VCA', text: 'Visa Cartão ATM' },
    { value: 'VCC', text: 'Visa Cartão de Crédito' },
    { value: 'VCD', text: 'Visa Cartão de Débito' },
    { value: 'VCP', text: 'Visa Cartão Pré-Pago' },
    { value: 'VDC', text: 'Verdecard Cartão de Crédito' },
    { value: 'VIC', text: 'Visa Internacional Compra Crédito' },
    { value: 'VID', text: 'Visa Internacional Compra Débito' },
  ],
  Credenciadoras: [
    { value: ' ', text: 'Todos' },
    { value: '00000208', text: 'BRB – BANCO DE BRASÍLIA S.A' },
    { value: '33171211', text: 'ACQIO ADQUIRÊNCIA S.A' },
    { value: '14796606', text: 'ADYEN DO BRASIL LTDA' },
    { value: '13776742', text: 'AGILITAS SOLUÇÕES DE PAGAMENTOS LTDA' },
    { value: '20520298', text: 'BANCO BONSUCESSO S.A. ADQUIRENTE' },
    { value: '31872495', text: 'BANCO C6 S.A' },
    { value: '02038232', text: 'BANCO COOPERATIVO SICOOB S.A ' },
    { value: '01181521', text: 'BANCO COOPERATIVO SICREDI S.A.' },
    { value: '61033106', text: 'BANCO CREFISA S.A' },
    { value: '58497702', text: 'BANCO LETSBANK S.A.' },
    { value: '68900810', text: 'BANCO RENDIMENTO S.A.' },
    { value: '58160789', text: 'BANCO SAFRA S.A.' },
    { value: '04814563', text: 'BANCO SOROCRED S.A - BANCO MULTIPLO' },
    { value: '17351180', text: 'BANCO TRIÂNGULO S.A.' },
    {
      value: '28127603',
      text: 'BANESTES S.A. - BANCO DO ESTADO DO ESPÍRITO SANTO',
    },
    { value: '92934215', text: 'BANRISUL CARTÕES S.A.' },
    {
      value: '20551972',
      text: 'BEBLUE SOLUÇÕES DE CASHBACK, SERVIÇOS PROMOCIONAIS E MEIOS DE PAGAMENTOS S.A',
    },
    { value: '30798783', text: 'BEN BENEFÍCIOS E SERVIÇOS S.A.' },
    {
      value: '28080769',
      text: 'BOLT CARD CREDENCIADORA DE CARTAO DE CREDITO LTDA',
    },
    { value: '35542555', text: 'CARDPAY BRASIL SERVICOS DE INTERNET LTDA' },
    { value: '13207930', text: 'CHECKOUT DO BRASIL LTDA' },
    { value: '01027058', text: 'CIELO S.A.' },
    {
      value: '18189547',
      text: 'CLOUDWALK MEIOS DE PAGAMENTOS E SERVICOS LTDA ',
    },
    { value: '01425787', text: 'CREDICARD' },
    { value: '17803384', text: 'DIAMANTE SERVIÇOS DIGITAIS LTDA' },
    { value: '08744817', text: 'DOCK SOLUCOES EM MEIOS DE PAGAMENTO S A' },
    { value: '24080493', text: 'EBANX PAGAMENTOS LTDA ' },
    { value: '59158642', text: 'EDENRED SOLUÇÕES DE PAGAMENTOS HYLA S.A' },
    { value: '12592831', text: 'ELAVON DO BRASIL SA' },
    { value: '52556578', text: 'ELGIN S.A' },
    { value: '09227084', text: 'ELO SERVIÇOS S.A' },
    {
      value: '10506341',
      text: 'ENOPP SERVIÇOS DE GESTÃO DE NEGÓCIOS E PROJETOS LTDA',
    },
    { value: '17768068', text: 'ESMERALDA SERVIÇOS DIGITAIS LTDA' },
    { value: '04556068', text: 'EVOLUSERVICES MEIOS DE PAGAMENTO LTDA - EPP' },
    { value: '00714671', text: 'EWALLY TECNOLOGIA E SERVIÇOS S.A.' },
    { value: '04962772', text: 'FD DO BRASIL SOLUÇÕES DE PAGAMENTO LTDA' },
    {
      value: '10440482',
      text: 'GETNET ADQUIRENCIA E SERVIÇOS PARA MEIOS DE PAGAMENTO S.A.',
    },
    { value: '17887874', text: 'GLOBALPAYMENTS SERVIÇOS DE PAGAMENTOS S.A' },
    { value: '22177858', text: 'GRANITO SOLUÇÕES EM PAGAMENTO S.A' },
    { value: '06308851', text: 'HAGANÁ FOMENTO MERCANTIL LTDA' },
    { value: '13884775', text: 'HUB PAGAMENTOS S.A.' },
    {
      value: '14380200',
      text: 'IFOOD.COM AGÊNCIA DE RESTAURANTES ONLINE S.A.',
    },
    { value: '17344776', text: 'IZETTLE DO BRASIL MEIOS DE PAGAMENTO LTDA' },
    { value: '13427325', text: 'LAUNCH PAD TECNOLOGIA E SERVIÇOS LTDA' },
    { value: '32971064', text: 'LISTO INSTITUIÇÃO DE PAGAMENTO LTDA' },
    { value: '09614276', text: 'M4 PRODUTOS E SERVIÇOS S.A.' },
    {
      value: '08508546',
      text: 'MAXICARD CONSULTORIA DE NEGOCIOS EM TECNOLOGIA LTDA',
    },
    { value: '10573521', text: 'MERCADOPAGO.COM REPRESENTACOES LTDA.' },
    { value: '23612423', text: 'PAG.AI TECNOLOGIA E INOVAÇÃO SA       ' },
    { value: '08561701', text: 'PAGSEGURO INTERNET S.A.  ' },
    { value: '15673592', text: 'PAYU BRASIL INTERMEDIAÇÃO DE NEGÓCIOS LTDA' },
    { value: '22896431', text: 'PICPAY SERVIÇOS S.A.' },
    { value: '17079937', text: 'PINBANK BRASIL - PAGAMENTOS INTELIGENTES S.A' },
    { value: '18191228', text: 'PJBANK PAGAMENTOS S.A. ' },
    {
      value: '17829537',
      text: 'PLANET PAYMENT DO BRASIL SERVICOS DE TECNOLOGIA DE INFORMACOES LTDA',
    },
    {
      value: '01722480',
      text: 'QUERO-QUERO VERDECARD INSTITUIÇÃO DE PAGAMENTO S.A',
    },
    { value: '01425787', text: 'REDECARD S.A.' },
    { value: '14233366', text: 'RP TECNOLOGIA E MEIOS DE PAGAMENTO S.A.' },
    { value: '17803403', text: 'SAFIRA SERVIÇOS DIGITAIS LTDA' },
    { value: '12901364', text: 'SAQUE E PAGUE REDE DE AUTOATENDIMENTO' },
    {
      value: '03847413',
      text: 'SEAC - SERGIPE ADMINISTRADORA DE CARTOES E SERVICOS LTDA',
    },
    { value: '29759316', text: 'SERVNET ADMINISTRACAO DE CARTOES LTDA ' },
    { value: '03766873', text: 'SICOOB SOLUÇÕES DE PAGAMENTO LTDA' },
    { value: '13207930', text: 'SLED S.A.' },
    { value: '60114865', text: 'SOROCRED MEIOS DE PAGAMENTO' },
    { value: '14625224', text: 'STELO S.A' },
    { value: '16501555', text: 'STONE PAGAMENTOS S.A.' },
    { value: '22121209', text: 'STRIPE BRASIL SOLUÇÕES DE PAGAMENTO LTDA' },
    { value: '16668076', text: 'SUMUP SOLUÇÕES DE PAGAMENTO BRASIL LTDA' },
    { value: '08718431', text: 'WIRECARD BRASIL S.A.' },
    {
      value: '00991143',
      text: 'WORLDPAY DO BRASIL PROCESSAMENTO DE PAGAMENTOS LTDA',
    },
  ],
  Subcredenciadoras: [
    { value: ' ', text: 'Todos' },
    { value: '00714671', text: 'EWALLY TECNOLOGIA E SERVIÇOS S.A.' },
    { value: '18033552', text: '99 TECNOLOGIA LTDA' },
    { value: '18928397', text: 'ADIQPLUS INSTITUICAO DE PAGAMENTO LTDA' },
    { value: '14796606', text: 'ADYEN DO BRASIL LTDA' },
    { value: '13776742', text: 'AGILITAS SOLUÇÕES DE PAGAMENTOS LTDA' },
    { value: '28494032', text: 'ALPE INTERMEDIACAO DE NEGOCIOS S.A. ' },
    { value: '15436940', text: 'AMAZON SERVICOS DE VAREJO DO BRASIL LTDA. ' },
    { value: '17768534', text: 'AMETISTA SERVIÇOS DIGITAIS LTDA' },
    { value: '00776574', text: 'B2W COMPANHIA DIGITAL' },
    {
      value: '20551972',
      text: 'BEBLUE SOLUÇÕES DE CASHBACK, SERVIÇOS PROMOCIONAIS E MEIOS DE PAGAMENTOS S.A',
    },
    { value: '07355049', text: 'BRASPAG - TECNOLOGIA EM PAGAMENTO LTDA' },
    {
      value: '18189547',
      text: 'CLOUDWALK MEIOS DE PAGAMENTOS E SERVICOS LTDA ',
    },
    {
      value: '18827467',
      text: 'CRISTAL ADMINISTRADORA DE CARTOES DE CREDITO LTDA',
    },
    { value: '17803384', text: 'DIAMANTE SERVIÇOS DIGITAIS LTDA' },
    { value: '25021356', text: 'DLOCAL BRASIL PAGAMENTOS LTDA' },
    { value: '24080493', text: 'EBANX PAGAMENTOS LTDA ' },
    { value: '59158642', text: 'EDENRED SOLUÇÕES DE PAGAMENTOS HYLA S.A' },
    { value: '52556578', text: 'ELGIN S.A' },
    {
      value: '10506341',
      text: 'ENOPP SERVIÇOS DE GESTÃO DE NEGÓCIOS E PROJETOS LTDA',
    },
    { value: '18577728', text: 'ESFERA 5 TECNOLOGIA E PAGAMENTOS S.A' },
    { value: '17768068', text: 'ESMERALDA SERVIÇOS DIGITAIS LTDA' },
    { value: '04556068', text: 'EVOLUSERVICES MEIOS DE PAGAMENTO LTDA - EPP' },
    { value: '09089356', text: 'GERENCIANET S/A' },
    { value: '11200418', text: 'GFG COMERCIO DIGITAL LTDA. ' },
    { value: '22177858', text: 'GRANITO SOLUÇÕES EM PAGAMENTO S.A' },
    { value: '06308851', text: 'HAGANÁ FOMENTO MERCANTIL LTDA' },
    {
      value: '14380200',
      text: 'IFOOD.COM AGÊNCIA DE RESTAURANTES ONLINE S.A.',
    },
    { value: '17344776', text: 'IZETTLE DO BRASIL MEIOS DE PAGAMENTO LTDA' },
    { value: '13427325', text: 'LAUNCH PAD TECNOLOGIA E SERVIÇOS LTDA' },
    { value: '27547510', text: 'LINX PAY MEIOS DE PAGAMENTO LTDA' },
    { value: '20250105', text: 'LISTO TECNOLOGIA S.A.' },
    { value: '26794946', text: 'LUCREE SOLUCOES INTELIGENTES LTDA.' },
    { value: '09614276', text: 'M4 PRODUTOS E SERVIÇOS S.A.' },
    { value: '10490181', text: 'MADEIRAMADEIRA COMERCIO ELETRONICO S.A' },
    { value: '17948578', text: 'MAGALU PAGAMENTOS' },
    {
      value: '08508546',
      text: 'MAXICARD CONSULTORIA DE NEGOCIOS EM TECNOLOGIA LTDA',
    },
    { value: '33444505', text: 'MR PAGAMENTOS SA' },
    {
      value: '35524559',
      text: 'NATURA & CO PAY SERVIÇOS FINANCEIROS E TECNOLOGIA EM PAGAMENTOS ELETRÔNICOS LTDA',
    },
    { value: '02445579', text: 'ONIX SERVICOS DE VALOR AGREGADO LTDA' },
    { value: '18727053', text: 'PAGAR.ME PAGAMENTOS S.A.' },
    { value: '21262661', text: 'PAGOLIVRE TECNOLOGIA S.A ' },
    { value: '08561701', text: 'PAGSEGURO INTERNET S.A.  ' },
    { value: '03816413', text: 'PAGUEVELOZ SERVICOS DE PAGAMENTO LTDA' },
    {
      value: '06167186',
      text: 'PAYGO ADMINISTRADORA DE MEIOS DE PAGAMENTOS LTDA',
    },
    { value: '15673592', text: 'PAYU BRASIL INTERMEDIAÇÃO DE NEGÓCIOS LTDA' },
    { value: '08965639', text: 'PAYU BRASIL INTERMEDIAÇÃO DE NEGÓCIOS LTDA' },
    { value: '22896431', text: 'PICPAY SERVIÇOS S.A.' },
    { value: '17079937', text: 'PINBANK BRASIL - PAGAMENTOS INTELIGENTES S.A' },
    { value: '18191228', text: 'PJBANK PAGAMENTOS S.A. ' },
    {
      value: '07945233',
      text: 'POLOCRED - SOCIEDADE DE CREDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LTDA',
    },
    {
      value: '36382680',
      text: 'QUERO 2 PAY SOLUÇÕES EM MEIOS DE PAGAMENTOS LTDA ',
    },
    { value: '26900161', text: 'RAPPI BRASIL INTERMEDIACAO DE NEGOCIOS LTDA' },
    { value: '25104230', text: 'ROADPASS PAYMENTS & URBAN MOBILITY LTDA' },
    { value: '14233366', text: 'RP TECNOLOGIA E MEIOS DE PAGAMENTO S.A.' },
    { value: '17803403', text: 'SAFIRA SERVIÇOS DIGITAIS LTDA' },
    {
      value: '03847413',
      text: 'SEAC - SERGIPE ADMINISTRADORA DE CARTOES E SERVICOS LTDA',
    },
    { value: '14625224', text: 'STELO S.A' },
    { value: '16501555', text: 'STONE PAGAMENTOS S.A.' },
    { value: '22121209', text: 'STRIPE BRASIL SOLUÇÕES DE PAGAMENTO LTDA' },
    { value: '16668076', text: 'SUMUP SOLUÇÕES DE PAGAMENTO BRASIL LTDA' },
    { value: '17895646', text: 'UBER DO BRASIL TECNOLOGIA LTDA.' },
    { value: '08718431', text: 'WIRECARD BRASIL S.A.' },
    { value: '14338304', text: 'YAPAY PAGAMENTOS ONLINE LTDA' },
    { value: '19468242', text: 'ZOOP TECNOLOGIA E MEIOS DE PAGAMENTO S.A.' },
  ],
  SavePropostaCampoAuxiliar (th, callback) {
    const campos = [];

    if (
      [null, undefined].indexOf(th.model.Subcredenciadoras) < 0 &&
      [null, undefined].indexOf(th.model.SubcredenciadorasConcat)
    ) {
      campos.push({
        CodigoProposta: th.model.CodigoProposta || th.model.Codigo,
        NomeCampo: 'PropostaGarantia_' + th.model.SubcredenciadorasConcat,
        ValorCampo: th.model.Subcredenciadoras,
      });
    }
    if ([null, undefined].indexOf(th.model.PercArranjo) < 0) {
      campos.push({
        CodigoProposta: th.model.CodigoProposta || th.model.Codigo,
        NomeCampo: 'PropostaGarantia_PercOneracao',
        ValorCampo: th.model.PercArranjo,
      });
    }
    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) {
      campos.push({
        CodigoProposta: th.model.Codigo,
        NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR',
        ValorCampo: th.model.ObservacaoVendedor,
      });
    }

    if (campos.length > 0) {
      th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos }).then(
        (response) => {
          if (th.$api.UI.PostLoadData(response, true)) {
            if (callback && typeof callback === 'function') callback();
          }
        }
      );
    }
  },
});
export default ctrl;
